import { TspType } from '../model/tsp.types'
import { getSingleTspType } from './getSingleTspType'

export const getTspListLabelByTspType = (payee: { features?: { category_web?: string } }) => {
  switch (getSingleTspType(payee)) {
    case TspType.GAMES:
      return 'Донаты'
    case TspType.SERVICES:
      return 'Сервисы'
    case TspType.KEYS:
      return 'Ключи'
    default:
      return '/'
  }
}
